export default __webpack_public_path__ + "static/media/redux-from-spaghetti-to-reducer.f77e6d51.png";